"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerFactory = void 0;
const core_1 = require("@bimser/core");
const triggers_1 = require("../entities/triggers");
const enums_1 = require("../enums");
function triggerFactory(type) {
    if (!(0, core_1.isNullOrUndefined)(type)) {
        switch (type) {
            case enums_1.ETriggerType.Cron:
                return (0, triggers_1.CronTriggerFactory)();
            case enums_1.ETriggerType.DailyTimeInterval:
                return (0, triggers_1.DailyTimeTriggerFactory)();
            case enums_1.ETriggerType.Simple:
                return (0, triggers_1.SimpleTriggerFactory)();
        }
    }
}
exports.triggerFactory = triggerFactory;
//# sourceMappingURL=triggerFactory.js.map